export enum CookieKeys {
  COOKIE_LANGUAGE = 'hmLangCookie',
  COOKIE_PWA_BANNER = 'hmClubPwaBanner'
}
